// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Res, setRes, TFunc, UI, uqStringify } from "tonva-react";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { FieldItem, FieldItemInt, FieldItemNum, FieldItemString, FieldItemId } from "tonva-react";
import { IxRandCustomerPoolTimes } from "./JkCoupon";

/*--fields--*/
const fields = {
	ix: {
		"name": "ix",
		"type": "id",
		"isKey": false,
		"label": "Ix"
	} as FieldItemId,
	xi: {
		"name": "xi",
		"isKey": false,
		"label": "Xi"
	} as undefined,
	value: {
		"name": "value",
		"type": "integer",
		"isKey": false,
		"widget": "updown",
		"label": "Value"
	} as FieldItemInt,
};
/*==fields==*/

const fieldArr: FieldItem[] = [
	fields.xi, fields.value, 
];

export const ui: UI = {
	label: "IxRandCustomerPoolTimes",
	fieldArr,
	fields,
};

const resRaw: Res<any> = {
	$zh: {
	},
	$en: {
	}
};
const res: any = {};
setRes(res, resRaw);

export const t:TFunc = (str:string|JSX.Element): string|JSX.Element => {
	return res[str as string] ?? str;
}

export function render(item: IxRandCustomerPoolTimes):JSX.Element {
	return <>{uqStringify(item)}</>;
};
